module.exports = __webpack_public_path__ + "static/Decline-20f27606f13b81a4c61a50231bb68c21.png";